import { forwardRef } from 'react';

import * as ScrollArea from '@radix-ui/react-scroll-area';

import styles from './ScrollView.module.css';

export const ScrollView = forwardRef((props, ref) => (
  <ScrollArea.Root
    className={styles.scrollAreaRoot}
    style={{
      height: props.height,
      ...props.css
    }}
  >
    <ScrollArea.Viewport className={styles.scrollAreaViewport}>
      <div className={`${styles.box} ${props.className}`} ref={ref}>
        {props.children}
      </div>
    </ScrollArea.Viewport>
    <ScrollArea.Scrollbar
      className={styles.scrollAreaScrollbar}
      orientation='vertical'
    >
      <ScrollArea.Thumb className={styles.scrollAreaThumb} />
    </ScrollArea.Scrollbar>
    <ScrollArea.Scrollbar
      className={styles.scrollAreaScrollbar}
      orientation='horizontal'
    >
      <ScrollArea.Thumb className={styles.scrollAreaThumb} />
    </ScrollArea.Scrollbar>
    <ScrollArea.Corner className={styles.scrollAreaCorner} />
  </ScrollArea.Root>
));

ScrollView.displayName = 'ScrollView';
